import { Box, Button, Grid, Stack } from "@mantine/core";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import * as faceapi from "@vladmandic/face-api/dist/face-api.esm.js";
import i18next from "i18next";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bars } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import ManpowerLogo from "../../assets/images/logos/MPG_BE_Logo_SS_STK_MC_RGB_REG.png";
import FaceVerification from "../../components/Attendance/FaceVerification";
import Logo from "../../components/Logo";
import LoadingModal from "../../components/Modal/LoadingModal";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config";
import { GET, newFetch, POST, PUT } from "../../helpers/fetch";
import getLocation from "../../helpers/geolocator";
import { to12Hr, toWeekEndDate, toWeekStartDate } from "../../helpers/moment";
import Header from "./Header";
import "./style.css";

const { LOCATION_API_URL, LOCATION_API_SECRET_KEY, SERVER_URL } = config;

const Attendance = () => {
  const loc = useLocation();
  const pathname = loc.pathname.split("/");
  const videoRef = useRef();
  const [src, setSrc] = useState();
  const [imgSrc, setImgSrc] = useState();
  const [showModalFaceVerification, setShowModalFaceVerification] =
    useState(false);
  const [type, setType] = useState(null);
  const [schedules, setSchedules] = useState(null);
  const [associateSites, setAssociateSites] = useState(null);
  const [siteId, setSiteId] = useState(null);
  const [activeClient, setActiveClient] = useState(null);
  const [apiLocation, setApiLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const cancelButtonRef = useRef(false);
  const [faceVerificationInterval, setFaceVerificationInterval] = useState();
  const [ssoRefreshTokenModal, setSsoRefreshTokenModal] = useState(false);
  const [customHTMLSite, setCustomHTMLSite] = useState(null);
  const [customHTMLShift, setCustomHTMLShift] = useState(null);
  const [toggleSiteTime, setToggleSiteTime] = useState(null);
  let siteArr = [];

  React.useEffect(() => {
    renderSiteOptions();
  }, [customHTMLSite]);

  React.useEffect(() => {
    associateSites &&
      setCustomHTMLSite(`<div>
    <div id="site-list">
      ${
        associateSites &&
        associateSites
          .map(
            (site) =>
              `<button class="site-button" data-id="${site.id}">${site.name}</button>`
          )
          .join("")
      }
    </div>
  </div>`);
  }, [associateSites]);

  React.useEffect(() => {
    schedules &&
      setCustomHTMLShift(`<div>
    <div id="site-list">
      ${
        schedules &&
        schedules
          .sort(
            (a, b) =>
              moment(a.start_time, "HH:mm:ss") -
              moment(b.start_time, "HH:mm:ss")
          )
          .map(
            (shift, index) =>
              `<button key="${index}" class="site-button assigend-shift-button" data-id='${JSON.stringify(
                shift
              )}'>${shift.shift ? shift.shift : "Unknown"} 
              ${to12Hr(shift.start_time)} - ${to12Hr(shift.end_time)}</button>`
          )
          .join("")
      }
    </div>
  </div>`);
  }, [schedules]);

  React.useEffect(() => {
    if (toggleSiteTime !== null) {
      followSite(siteId, type);
    }
  }, [toggleSiteTime]);

  const { t } = useTranslation();
  const [message, setMessage] = useState(t("initializing"));
  const handleClick = (e) => {
    i18next.changeLanguage(e);
  };

  const NotifyBeforeClockIn = async (time_type) => {
    const { value: accept } = await Swal.fire({
      title: "Announcement",
      html: t("announcement_1"),
      confirmButtonText: 'Continue <i class="fa fa-arrow-right"></i>',
    });

    if (accept) {
      handleProceedTime(time_type);
    }
  };

  const handleProceedTime = async (time_type) => {
    if (
      activeClient.site_details.enable_tablet_biometrics !== undefined &&
      activeClient.site_details.enable_tablet_biometrics
    ) {
      showSiteOptions(time_type);
    } else {
      await fetchSchedules(siteId);
      handleOpenModalFaceVerification(time_type);
    }
  };

  const fetchClientSites = async (site_id) => {
    const api_path = `/external/site/${site_id}/client/details`;
    const response = await newFetch(GET, api_path);

    if (response?.success) {
      setActiveClient(response.data);
      setTimeout(() => {
        setLoading(false);
      }, 3000);
      return response.data;
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
      return false;
    }
  };

  const getAssociateLocation = async (site_id) => {
    const details = await fetchClientSites(site_id);
    if (details) {
      if (!details.site_details.enable_geolocation) return;

      const position = await getLocation();
      if (position.Long != 0) {
        const res = await fetch(
          LOCATION_API_URL +
            `${position.Long},${position.Lat}` +
            LOCATION_API_SECRET_KEY
        );
        const data = await res.json();

        if (data.features.length == 0) {
          setApiLocation("Location not found");
        } else {
          setApiLocation(data.features[0].place_name);
        }
      } else {
        ToastUtil.warning("Record will be saved without location");
        setApiLocation("User did not enable location data");
      }
    }
  };

  const fetchSchedules = async (site_id) => {
    let todayShifts = [];
    const details = await fetchClientSites(site_id);
    const api_path = `/external/site/${site_id}/schedule`;
    const response = await newFetch(POST, api_path, {
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    });

    if (details && response.success) {
      let schedulesData = response.data;
      const currentWeekStartDate = toWeekStartDate(
        moment(),
        details.client.start_day
      );
      const currentWeekEndDate = toWeekEndDate(
        moment(),
        details.client.start_day
      );
      const activeDate = moment().format("YYYY-MM-DD");

      //create site schedule
      if (details.site_details.enable_br_upload === false) {
        if (schedulesData.length === 0) {
          const api_path = `/external/site/${site_id}/schedule/create`;
          const resp = await newFetch(POST, api_path, {
            start_date: moment(currentWeekStartDate).format("YYYY-MM-DD"),
            end_date: moment(currentWeekEndDate).format("YYYY-MM-DD"),
            activeDate,
          });

          if (resp.success) {
            schedulesData = resp.scheduleArr;
          }
        }
      }

      if (schedulesData.length > 0) {
        schedulesData.map((sched) => {
          todayShifts.push({
            schedule_id: sched.id,
            date: sched.date,
            shift_id: sched.shift_id,
            shift: sched.shift.name,
            site_id: sched.shift.site_id,
            site: details.site_name,
            start_time: sched.shift.start_time,
            end_time: sched.shift.end_time,
            time_in: null,
            time_out: null,
            status: 1,
            vto: null,
          });
        });
      }

      setSchedules(todayShifts);
    }
  };

  const fetchSourceImage = async (site_id) => {
    const api_path = `/external/site/${site_id}/verification_img_source`;
    const response = await newFetch(GET, api_path);

    if (response?.success) {
      let data = response.data;
      await data.map((x) => {
        siteArr.push([
          x.associate_id,
          new Float32Array(JSON.parse(x.descriptor)),
        ]);
      });
      setImgSrc(siteArr);
    } else {
      ToastUtil.error(response?.message);
    }
  };

  const startVideo = async () => {
    navigator.mediaDevices
      ?.getUserMedia({ video: true })
      .then(function (stream) {
        const video = document.querySelector("video");
        if ("srcObject" in video) {
          videoRef.current.srcObject = stream;
          setSrc(stream);
        }
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
      });
  };

  const followSite = async (siteId, ftype) => {
    setLoading(true);
    await fetchSourceImage(siteId);
    await fetchSchedules(siteId);
    setLoading(false);
    handleOpenModalFaceVerification(ftype);
  };

  const checkMySchedule = async (assocId, timeType) => {
    let api_path = `/external/associate/site/${siteId}/myschedule_non_login`;
    try {
      const response = await newFetch(PUT, api_path, {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        associate_id: assocId,
        type: timeType,
      });

      if (
        response.success == false &&
        response.message == "system_date_different"
      ) {
        Swal.fire({
          icon: "error",
          title: `Error`,
          html: ` ${t(response.message)}`,
        });
      }

      //has assigned shedule
      if (response.data.myShifts.length > 0) {
        let mySched = "";
        if (response.data.myShifts.length === 1) {
          mySched = response.data.myShifts;
        } else if (response.data.myShifts.length > 1) {
          if (type == "clock in") {
            setSchedules(response.data.myShifts);
            renderAssignedShiftOptions(
              response.data.assoc_name,
              assocId,
              timeType
            );
          }
        }

        if (mySched.length > 0) {
          clockInOut(
            assocId,
            _.reduce(
              mySched,
              function (memo, current) {
                return _.assign(memo, current);
              },
              {}
            ),
            timeType
          );
        } else {
          if (timeType == "clock out") {
            ToastUtil.error(t("clockout_fail"));
          }
        }
      } else {
        //doesn't have schedule
        if (
          timeType == "clock in" &&
          activeClient.site_details.enable_br_upload === false &&
          response.message != "system_date_different"
        ) {
          renderAssignedShiftOptions(
            response.data.assoc_name,
            assocId,
            timeType
          );
        } else {
          Swal.fire({
            icon: "error",
            title: `${t("sorry")} ${response.data.assoc_name}`,
            html: ` ${t(response.message)} <b>${
              response.data?.shift_name ? response.data?.shift_name : ""
            }</b>`,
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: `Internal Server Error`,
        text: ``,
      });
    }
  };

  const clockInOut = async (assoc_id, selectedSchedule, timeType) => {
    setSsoRefreshTokenModal(true);
    let data = {
      location: apiLocation,
      associate_ids: [assoc_id],
      schedule: selectedSchedule,
      translated_message: {
        thank_you_clockin: t("thank_you_clockin"),
        thank_you_clockout: t("thank_you_clockout"),
        break_in_success: t("break_in_success"),
        break_out_success: t("break_out_success"),
      },
    };

    data =
      timeType == "clock in"
        ? {
            ...data,
            time_in: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    data =
      timeType == "clock out"
        ? {
            ...data,
            time_out: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    data =
      timeType == "break in"
        ? {
            ...data,
            break_in: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    data =
      timeType == "break out"
        ? {
            ...data,
            break_out: moment().format("YYYY-MM-DD HH:mm"),
          }
        : data;

    let api_path = `/external/associate/${selectedSchedule.schedule_id}/clockinout_update`;
    let response = await newFetch(PUT, api_path, data);
    if (response.success) {
      setSsoRefreshTokenModal(false);
      Swal.fire({
        title: response.message,
        html: clockInOutDialogue(response.data),
        confirmButtonText: "Close",
      });
    } else {
      setSsoRefreshTokenModal(false);
      Swal.fire({
        title: response.message,
        confirmButtonText: "Close",
      });
    }
  };

  const showSiteOptions = (attendanceType) => {
    setType(attendanceType);
    setAssociateSites(activeClient.sites);
    renderSiteOptions();
  };

  const renderSiteOptions = () => {
    customHTMLSite &&
      Swal.fire({
        title: t("please_select_site"),
        html: customHTMLSite,
        showConfirmButton: false,
        didOpen: () => {
          // Add event listeners for the buttons
          const siteButtons = document.querySelectorAll(".site-button");
          siteButtons.forEach((button) => {
            button.addEventListener("click", () => {
              const siteId = button.getAttribute("data-id");
              // Handle the button click (e.g., followSite(siteId))
              setSiteId(siteId);
              setToggleSiteTime(!toggleSiteTime);
              // Close the modal
              Swal.close();
            });
          });
        },
      });
  };

  const renderAssignedShiftOptions = (name, assocId, timeType) => {
    customHTMLShift &&
      Swal.fire({
        title: `${t("hey")} ${name} ${t("please_select_shift")}`,
        html: customHTMLShift,
        showConfirmButton: false,
        didOpen: () => {
          // Add event listeners for the buttons
          const assignedShiftButtons = document.querySelectorAll(
            ".assigend-shift-button"
          );
          assignedShiftButtons.forEach((button) => {
            button.addEventListener("click", () => {
              const shiftJsonString = button.getAttribute("data-id");
              // Convert the object to a JSON-formatted string
              const shiftParsedObject = JSON.parse(shiftJsonString);
              // Handle the button click (e.g., clockInOut(shiftParsedObject))
              clockInOut(assocId, shiftParsedObject, timeType);
              // Close the modal
              Swal.close();
            });
          });
        },
      });
  };

  const handleOpenModalFaceVerification = (ftype) => {
    setMessage(t("initializing"));

    //only trigger on first load of the page
    if (!cancelButtonRef.current) {
      document.getElementById("btn-cancel").click();
      setTimeout(() => {
        clearInterval(faceVerificationInterval);
        setType(ftype);
        startVideo();
        setShowModalFaceVerification(true);
        cancelButtonRef.current = true;
      }, 200);
    } else {
      clearInterval(faceVerificationInterval);
      setType(ftype);
      startVideo();
      setShowModalFaceVerification(true);
    }
  };

  const randomColor = (min, max) => {
    const colors = ["#ff8c00", "#466EA5", "#00008b", "#8fbc8f", "#228b22"];
    const number = Math.floor(Math.random() * (max - min + 1) + min);

    return colors[number];
  };

  const clockInOutDialogue = (data) => {
    return `<div class="clockinout-container">
      <div class="associate-info">
        <img src="${SERVER_URL}/${
      data.image
    }" alt="default" class="rounded-circle border associate-image" />
        <div class="associate-details">
          <h3>${data.lastname}</h3>
          <h4>${data.site}</h4>
        </div>
      </div>
      <div class="attendance-info">
        <div class="attendance-info-label">
          <h4>IN</h4>
          <h4>OUT</h4>
          <h4>Break</h4>
        </div>
        <div class="attendance-info-value">
          <h5>${data.time_in || "--"}</h5>
          <h5>${data.time_out || "--"}</h5>
          <h5>${data.break || "--"}</h5>
        </div>
      </div>
    </div>`;
  };

  const closeLoadingModal = () => {
    setSsoRefreshTokenModal(false);
  };

  useEffect(() => {
    let site_id = "";
    if (Array.isArray(pathname) && pathname.length > 3) {
      site_id = pathname[3];
      fetchSourceImage(site_id);
      fetchSchedules(site_id);
      setSiteId(site_id);
    }
    setLoading(true);
    //getAssociateLocation(site_id);

    const loadModels = async () => {
      const MODEL_URL = process.env.PUBLIC_URL + "/models";
      Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
        faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
      ]).then(startVideo);
    };

    setTimeout(() => {
      loadModels();
      setShowModalFaceVerification(true);
    }, 3000);

    setTimeout(() => {
      let modalOverlay = document.getElementsByClassName("ReactModal__Overlay");
      modalOverlay[0].style.backgroundColor = "unset";
      modalOverlay[0].style.position = "unset";

      let modalContent = document.getElementsByClassName("ReactModal__Content");
      modalContent[0].style.position = "absolute";
      modalContent[0].style.left = "-500px";
    }, 3050);

    sessionStorage.setItem(
      "faceApp",
      JSON.stringify({ up_time: moment().format("YYYY-MM-DD HH:mm") })
    );
  }, []);

  return (
    <React.Fragment>
      {loading ? (
        <Stack
          align="center"
          spacing="xs"
          justify="center"
          sx={(theme) => ({
            height: 600,
          })}
        >
          <Bars
            height="80"
            width="80"
            color={randomColor(0, 4)}
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
          <Typography>Loading, Please wait...</Typography>
        </Stack>
      ) : (
        <Box
          sx={(theme) => ({
            height: "100vh",
          })}
        >
          <Box
            sx={(theme) => ({
              position: "absolute",
              width: 250,
              height: 250,
              backgroundColor: "#C3EAFF",
              borderRadius: 150,
              opacity: "70%",
              left: -90,
              top: -10,
            })}
          >
            Cicle Blue
          </Box>
          <Box
            sx={(theme) => ({
              position: "absolute",
              width: 250,
              height: 250,
              backgroundColor: "#FFC3C3B2",
              borderRadius: 150,
              opacity: "70%",
              left: -10,
              top: -130,
            })}
          >
            Cicle Pink
          </Box>
          <Box
            sx={(theme) => ({
              paddingTop: "60px",
              justifyContent: "flex-end",
            })}
          >
            <Logo
              image={ManpowerLogo}
              addedStyles={{
                marginBottom: "5px",
              }}
            />
            <Stack align="center">
              <Header activeClient={activeClient} type={type}></Header>
            </Stack>
          </Box>
          <Box
            sx={(theme) => ({
              paddingTop: "10px",
            })}
          >
            {activeClient &&
            activeClient.site_details.enable_tablet_biometrics ? (
              <Stack align="center">
                {/* Clock In/Out Buttons */}
                <Grid gutter="xl" className="text-center">
                  <Grid.Col sm={6}>
                    <Button
                      onClick={() => NotifyBeforeClockIn("clock in")}
                      size="lg"
                      radius="md"
                      variant="filled"
                      sx={(theme) => ({
                        width: "175px",
                        height: "50px",
                      })}
                    >
                      {t("clockin")}
                    </Button>
                  </Grid.Col>
                  <Grid.Col sm={6}>
                    <Button
                      onClick={() => handleProceedTime("clock out")}
                      size="lg"
                      radius="md"
                      variant="filled"
                      color="red"
                      sx={(theme) => ({
                        width: "175px",
                        height: "50px",
                      })}
                    >
                      {t("clockout")}
                    </Button>
                  </Grid.Col>
                </Grid>

                {/* Break In/Out Buttons */}
                <Grid gutter="xl" className="text-center">
                  <Grid.Col sm={6}>
                    <Button
                      onClick={() => handleProceedTime("break in")}
                      radius="md"
                      size="xl"
                      variant="outline"
                      color="orange"
                      sx={(theme) => ({
                        width: "175px",
                        height: "50px",
                      })}
                    >
                      {t("break_in")}
                    </Button>
                  </Grid.Col>
                  <Grid.Col sm={6}>
                    <Button
                      onClick={() => handleProceedTime("break out")}
                      radius="md"
                      size="xl"
                      variant="outline"
                      color="orange"
                      sx={(theme) => ({
                        width: "175px",
                        height: "50px",
                      })}
                    >
                      {t("break_out")}
                    </Button>
                  </Grid.Col>
                </Grid>
              </Stack>
            ) : (
              <Stack align="center">
                <Typography variant="h6">
                  Clock In & Out module has been disabled. Please contact the
                  admin to activate.
                </Typography>
              </Stack>
            )}
            {activeClient &&
              activeClient.site_details.enable_tablet_biometrics && (
                <Box
                  sx={(theme) => ({
                    width: "100%",
                    position: "absolute",
                    paddingTop: "120px",
                  })}
                >
                  <Stack align="center">
                    <Typography>Translate to:</Typography>
                    {/* <div style={{paddingBottom:"10px"}}>test</div> */}

                    <Grid
                      className="text-center"
                      sx={(theme) => ({
                        bottom: "10px",
                        margin: "0px",
                      })}
                    >
                      <Grid.Col
                        span={6}
                        sx={(theme) => ({
                          width: "150px",
                        })}
                      >
                        <Link
                          onClick={(e) => handleClick("en")}
                          className="link-translate"
                        >
                          English (英语)
                        </Link>
                      </Grid.Col>
                      <Grid.Col
                        span={6}
                        sx={(theme) => ({
                          width: "150px",
                        })}
                      >
                        <Link
                          onClick={(e) => handleClick("chi")}
                          className="link-translate"
                        >
                          Mandarin (普通话)
                        </Link>
                      </Grid.Col>
                    </Grid>
                  </Stack>
                </Box>
              )}
          </Box>
        </Box>
      )}
      <FaceVerification
        type={type}
        imgSrc={imgSrc}
        src={src}
        videoRef={videoRef}
        faceapi={faceapi}
        showModalFaceVerification={showModalFaceVerification}
        setShowModalFaceVerification={setShowModalFaceVerification}
        checkMySchedule={checkMySchedule}
        faceVerificationInterval={faceVerificationInterval}
        setFaceVerificationInterval={setFaceVerificationInterval}
        cancelButtonRef={cancelButtonRef}
        setMessage={setMessage}
        message={message}
        t={t}
        siteId={siteId}
        fetchSourceImage={fetchSourceImage}
      />

      <LoadingModal
        isOpen={ssoRefreshTokenModal}
        onRequestClose={closeLoadingModal}
      />
    </React.Fragment>
  );
};

export default Attendance;
